import { Component, OnInit, Input } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';
import { AttachmentSearch } from '../../models/attachments';
import { attachmentCode, attachmentTypes, emptyFields } from '../../utilities/common-file';
import { CommonService } from '../../utilities/common-service';
import { NzTableData } from '../../utilities/nz-table.adapter';
import { TransactionService } from '../transactions.service';
@Component({
    selector: 'app-transaction-attachments',
    templateUrl: './attachment.component.html',
  })
  export class TransactionAttachemntComponent implements OnInit {
    @Input() selectedTransactionId: any;
    file:any;
    loading = false;
    uploading = false;
    emptyField = emptyFields;
    fileObject: NzUploadXHRArgs;
    fileList: NzUploadFile[] = [];
    private tableData: NzTableData<AttachmentSearch, any> = new NzTableData<AttachmentSearch, any>(new AttachmentSearch(),
    'transactionStatus');
    constructor(private transactionService: TransactionService, private notification: NzNotificationService,
                private modal: NzModalService, private commonService: CommonService) {}

    ngOnInit() {
      this.tableData.search.id = this.selectedTransactionId;
      this.tableData.search.code = attachmentCode.attachment;
      this.tableData.search.type = attachmentTypes.transaction;
      this.tableData.search.title = '';
      this.getAttachmentsList();
    }
    // beforeUploadAttachments = (file: NzUploadFile) => {
    //   this.file = file;
    //   this.fileList = this.fileList.concat(file);
    //   return new Observable((observer: Observer<boolean>) => {
    //     observer.complete();
    //   });
    // }

    //parsing issue fixing error 
      beforeUploadAttachments = (file: NzUploadFile) => {
      // keep a reference to the chosen file and show it in the list
      this.file = file;
      this.fileList = [file];

      // Prevent nz-upload from performing the automatic POST to the current origin.
      // The actual upload is performed manually in saveAdditionalDocument().
      return false;
    }
    saveAdditionalDocument() {     // Image upload while clicking save button.
         if (this.file) {
          this.notification.info('Processing', 'Please Wait', {
            nzKey: 'key'
          });
          const data = new FormData();
          data.append('file',this.file);
          data.append('referenceId', this.selectedTransactionId);
          data.append('type',attachmentTypes.transaction);
          data.append('code',attachmentCode.attachment);   
          data.append('title',this.tableData.search.title);  
          data.append('comments',this.tableData.search.comments);          
            this.commonService.uploadAttachmentsNew(data).subscribe((response: any) => {
              this.notification.success(response.message, '', {
                nzKey: 'key'
              });          
              this.file = null;
              this.fileList = [];
              this.tableData.search.title = '';
              this.tableData.search.comments='';
              this.getAttachmentsList();
            }, err => {
              this.file = null;
              this.fileList = [];
            });
        }else {
          this.notification.error('Please select file', '', {
            nzKey: 'key'
          });
        }
    }

getAttachmentsList(startFromPageOne: boolean = true): void {
   this.loading = true;
  this.tableData.data = [];
  if (startFromPageOne) {
    this.tableData.pageIndex = 1;
  }
   this.commonService.listAttachments(this.tableData).subscribe((response: any) => {
    this.loading = false;
    if (response.data && response.data.attachments) {
      this.tableData.total = response.data.total;
      this.tableData.data = response.data.attachments;
    }
  }, err => {
    this.loading = false;
    this.tableData.data = [];
  });
 }
 onIndexChange(event) {
  this.tableData.pageIndex = event;
  this.getAttachmentsList(false);
  }
 downloadAttachment(row) {
  this.notification.info('Download Processing', 'Please Wait', {
    nzKey : 'key'
  });
  this.commonService.downloadAttachments(this.selectedTransactionId, row.filename).subscribe((response: any) => {
    const blob = new Blob([response], { type: row.filetype });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = row.filename;
    link.click();
   });
 }
 showDeleteConfirm(item) {
  this.modal.confirm({
    nzTitle: 'Are you sure you want to delete this attachment?',
    nzOkText: 'Yes',
    nzOkType: 'danger',
    nzOnOk: () => this.deleteAttachment(item),
    nzCancelText: 'No',
    nzOnCancel: () => console.log('Cancel')
  });
}
deleteAttachment(item) {
  this.commonService.deleteAttachment(item.id).subscribe((response: any) => {
    this.notification.success(response.message, '', {
      nzKey: 'key'
    });
    this.getAttachmentsList();
  }, err => {

  });
}
private getBase64(img: File, callback: (img: string) => void): void {
          const reader = new FileReader();
          // tslint:disable-next-line: no-non-null-assertion
          reader.addEventListener('load', () => callback(reader.result!.toString()));
          reader.readAsDataURL(img);
        }
getUserType(role) {
  return this.commonService.getUserType(role);
}
}

